import {
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MerchantProcessorDialogComponent } from './editDialog/merchant-processor-dialog/merchant-processor-dialog.component';
import { MerchantProcessor } from '../../../models/merchant/merchantProcessor';
import { AccessManager } from '../../ui/access-manager/access-manager';
import {
  TextInputComponent,
  TextModes,
} from '../../ui/controls/text-input/text-input.component';
import {
  DdlInputComponent,
  DDLModes,
} from '../../ui/controls/ddl-input/ddl-input.component';
import { FormMode, MerchantAccountStatus } from '../../../core/constants';
import { BaseComponent } from '../../baseComponent';
import { SolutionDetails } from '../../../models/solution/solutionDetails';
import { CacheService } from '../../../core/storage/cacheService';
import { MerchantService } from '../../../models/merchant/merchantService';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import {
  FormValidator,
  ValidationMessage,
} from '../../../models/validation/formValidator';
import { iValidatedControl } from '../../ui/controls/iValidatedControl';
import { ListItem } from '../../../../../../../libs/Shared/components/model/listItem';

@Component({
  selector: 'app-merchant-processors',
  templateUrl: './merchant-processors.component.html',
  standalone: false,
})
export class MerchantProcessorsComponent extends BaseComponent {
  @Input() solution: SolutionDetails | undefined;
  @Input() processors: MerchantProcessor[] = [];
  @Input() merchantId: string | undefined;
  @Input() enableEditing: boolean = false;
  @Input() mode: FormMode = FormMode.View;
  @Input() onboarding: boolean = false;
  @Output() saved = new EventEmitter<boolean>();

  @ViewChildren(TextInputComponent) validatedTextBoxes:
    | QueryList<TextInputComponent>
    | undefined;
  @ViewChildren(DdlInputComponent) validatedDropDowns:
    | QueryList<DdlInputComponent>
    | undefined;

  inputModes = TextModes;
  ddlModes = DDLModes;
  allowAddMID: boolean = false;

  status: ListItem[] = CacheService.accountStatusList;
  processor: ListItem[] = CacheService.ccProcessorList;
  gateway: ListItem[] = CacheService.gatewayList;
  processorType: ListItem[] = CacheService.processingTypeList;

  onboardingProcessor: Partial<MerchantProcessor> = {
    merchantId: '',
    mid: '',
    processor: '',
    processorType: '',
    status: MerchantAccountStatus.Live,
    tokenVaultName: '',
    cardTerminalId: '',
    ppdTerminalId: '',
    ccdTerminalId: '',
    webTerminalId: '',
  };

  constructor(
    public dialog: MatDialog,
    private access: AccessManager,
    private merchantService: MerchantService,
    private uiErrorHandler: UIErrorHandler,
    private formValidator: FormValidator,
  ) {
    super();
    this.solution = new SolutionDetails({});
  }

  ngOnInit() {
    this.access
      .getUserAccess([
        AccessManager.AUTH_UPDATE_MERCHANT_PROCESSORS,
        AccessManager.AUTH_SELECT_MERCHANT_PROCESSORS,
      ])
      .then((accessRecord) => {
        if (accessRecord[AccessManager.AUTH_UPDATE_MERCHANT_PROCESSORS]) {
          this.allowAddMID = true;
        }
        this.enableEditing = this.enableEditing && this.allowAddMID;

        //this.selectMID(this.processors[0].mid);
      });
  }

  btnAddProcessor_click() {
    this.dialog.open(MerchantProcessorDialogComponent, {
      width: '500px',
      data: {},
    });
  }

  btnChangeType_click(type: string) {
    const processors = type.toString().split(',');
    this.onboardingProcessor.processorType = [];
    if (processors.includes('Fiserv')) {
      this.onboardingProcessor.processorType.push('Card');
    }
    if (processors.includes('Paya')) {
      this.onboardingProcessor.processorType.push('ACH');
    }
  }

  // btnChangeStatus_click(procId:string, newStatus:string) {

  //   if (confirm("Are you sure you want to change the status of MID " + procId + " to '" + newStatus + "'?")) {
  //     if (this.processors[0]) {
  //       this.merchantService.patchMerchantAccountStatus(procId, this.processors[0].status)
  //     }
  //   }

  // }

  selectMID(selector: string) {
    let tabs = document.getElementsByClassName('content selected');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].classList.remove('selected');
    }

    let tabContents = document.getElementsByClassName('tabMIDContent selected');
    for (var i = 0; i < tabContents.length; i++) {
      tabContents[i].classList.remove('selected');
    }

    let selectedTab = document.getElementById('tabMID_' + selector);
    selectedTab?.children[0].classList.add('selected');

    let selectedTabContent = document.getElementById(selector);
    selectedTabContent?.classList.add('selected');
  }

  public btnEdit_click() {
    //this.copyModelData(this.merchant, this.data);
    this.mode = FormMode.Edit;
  }

  btnEditProcessor_click(procID: string) {
    let p: Partial<MerchantProcessor> | undefined = undefined;

    for (var i = 0; i < this.processors.length; i++) {
      if (this.processors[i].id == procID) {
        p = this.processors[i];
        break;
      }
    }

    if (p) {
      const dialogRef = this.dialog.open(MerchantProcessorDialogComponent, {
        width: '500px',
        data: MerchantProcessor.clone(p),
      });
    }
    // dialogRef.afterClosed().subscribe(result => {

    //   if (result != undefined) {

    //     if (this.processors) {
    //       for (var i=0; i<this.processors.length; i++) {
    //         if (this.processors[i].id == result.id) {
    //           this.processors[i] = result;
    //         }
    //       }
    //     }

    //     this.saved.emit(true);
    //   }
    // });
  }

  public btnSaveClick() {
    if (this.processors) {
      if (confirm('Are you sure you want to make these changes?')) {
        this.merchantService
          .patchMerchantProcessor(this.processors)
          .then(() => {
            this.mode = FormMode.View;
            this.saved.emit(true);
          })
          .catch((error) => {
            this.uiErrorHandler.handleError(error);
          });
      }
    }
  }

  public btnCancelClick() {
    this.mode = FormMode.View;
    this.saved.emit(false);
  }

  public getData(data: Partial<MerchantProcessor>) {
    data.mid = this.onboardingProcessor.mid;
    data.achMid = this.onboardingProcessor.achMid;
    data.processor = this.onboardingProcessor.processor;
    data.processorType = this.onboardingProcessor.processorType;
    data.tokenVaultName = this.onboardingProcessor.tokenVaultName;
    data.gateway = this.onboardingProcessor.gateway;
    data.cardTerminalId = this.onboardingProcessor.cardTerminalId;
    data.ppdTerminalId = this.onboardingProcessor.ppdTerminalId;
    data.ccdTerminalId = this.onboardingProcessor.ccdTerminalId;
    data.webTerminalId = this.onboardingProcessor.webTerminalId;
  }

  public validate(): ValidationMessage[] {
    let errors: ValidationMessage[] = [];

    let validatedControls: iValidatedControl[] = [];

    if (this.validatedTextBoxes && this.validatedDropDowns) {
      validatedControls = validatedControls.concat(
        this.validatedTextBoxes.toArray(),
      );
      validatedControls = validatedControls.concat(
        this.validatedDropDowns.toArray(),
      );

      errors = this.formValidator.validate(validatedControls);
    }


    if (!this.onboardingProcessor.gateway) {
      errors.push(new ValidationMessage('gateway', 'Gateway is required'));
    }

    console.log(errors);
    return errors;
  }
}
